import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import {__} from 'js/tool/page/current';
import 'scss/components/login.scss';
import {hideInvalidationMessage} from 'js/reusable/auth/tool';
import LoginPolicy from 'js/reusable/auth/policy';
import useToggle from 'js/reusable/hooks/useToggle';
import LoginForm from 'js/reusable/auth/form';
import FacebookLoginForm from 'js/reusable/auth/facebook';
import LoginBox from 'js/reusable/auth/loginBox';
import {AuthResponse} from 'js/reusable/auth/types';

type IProps = {
	validationErrors?: AuthResponse | null;
	loading: boolean;
	fbLoading: boolean;
	certEmail: string;
}

const app = import.meta.env.REACT_APP_BUILD_TARGET;

function Login({validationErrors, loading, fbLoading, certEmail}: IProps) {
	const [policy, togglePolicy] = useToggle(false);

	return (
		<LoginBox>
			{
				validationErrors && validationErrors?.invalidationMessage &&
				<Alert
					variant="info"
					className="error-alert"
					onClose={hideInvalidationMessage}
					dismissible
				>
					<i className="fas fa-exclamation-triangle"/>
					{__(validationErrors?.invalidationMessage)}
				</Alert>
			}

			<div className="login-divider"/>

			<Row><Col><h1>{__(`fb:${app} login`)}</h1></Col></Row>

			<Form>
				{
					validationErrors &&
					(validationErrors.policy || validationErrors.fb_policy) &&
					<LoginPolicy
						togglePolicy={togglePolicy}
						policy={policy}
					/>
				}

				{
					(!validationErrors || !validationErrors.policy) &&
					!loading &&
					<FacebookLoginForm
						loading={fbLoading}
						policy={policy}
						validationErrors={validationErrors}
					/>
				}

				{
					(import.meta.env.REACT_APP_BUILD_TARGET === 'admin' ||
                    import.meta.env.REACT_APP_ENVIRONMENT === 'dev') &&
					(!validationErrors || (!validationErrors.policy && !validationErrors.fb_policy)) &&
					(!loading && !fbLoading) &&
					<div className="login-divider"><span>{__('fb:or')}</span></div>
				}

				{
					(import.meta.env.REACT_APP_BUILD_TARGET === 'admin' ||
                    import.meta.env.REACT_APP_ENVIRONMENT === 'dev') &&
					(!validationErrors || !validationErrors.fb_policy) &&
					!fbLoading &&
					<LoginForm
						loading={loading}
						policy={policy}
						validationErrors={validationErrors}
						certEmail={certEmail}
					/>
				}
			</Form>
		</LoginBox>
	);
}

export default Login;
